import React, { Component } from 'react';
import Flatpickr from 'react-flatpickr'
import { Chart } from 'react-google-charts';
import pdf from '../img/pdf.svg';
import csv from '../img/csv.svg';
import excel from '../img/excel.svg';
import print from '../img/print.svg';
import DateFilter from '../DateFilter.js'
import GroupBy from '../GroupBy.js'

class Reports extends React.PureComponent {
	constructor(props) {
		super(props);
		this.state = {
			active: false,
			activeReport: false,
			activeCall: false,
			dateFilter: false,
			groupBy: false,
			playingRecording: false,
			extraData: false,
			recLoading: false
		};
	}

	play = (call) => {
		this.setState({ playingRecording: true, activeCall: call }, function () {
			this.props.ws.send(JSON.stringify({ route: 'getRecording', call: this.state.activeCall }))
		})
	}
	viewExtraData = (data) => {
		console.log(data)
		console.log(decodeURIComponent(data))
		console.log(JSON.parse(decodeURIComponent(data)))
		this.setState({ extraData: JSON.parse(decodeURIComponent(data)) })
	}
	viewTranscript = (data) => {
		console.log(data)
		console.log(decodeURIComponent(data))
		console.log(JSON.parse(decodeURIComponent(data)))
		this.setState({ transcript: JSON.parse(decodeURIComponent(data)) })
	}
	formatRecordingName = (call) => {
		var d = new Date(call.dateTime).toLocaleDateString().replace(/\//gm, '.')
		var t = new Date(call.dateTime).toLocaleTimeString().replace(/:.. /gm, '').replace(/:/gm, '.')
		var cid = call.callerID.replace(/\+1/gm, '')
		var phone = '(' + cid.slice(0, 3) + ')' + cid.slice(3, 6) + '-' + cid.slice(6, 10)

		return (d + '_' + t + '_' + phone + '.wav')
	}
	cancel = () => {
		this.setState({ dateFilter: false, groupBy: false, loading: false, extraData: false, transcript: false, playingRecording: false, activeCall: false })
	}

	selectReport = (e) => {
		this.setState({ activeReport: JSON.parse(e.currentTarget.getAttribute('data-report')), parameters: {}, reportData: false })
	}

	cancelReport = (e) => {
		this.setState({ activeReport: false })
		this.props.ws.send(JSON.stringify({ route: 'newReport' }))
		this.forceUpdate()
	}

	updateReportParameter = (param, e) => {
		var newParameters = Object.assign({}, this.state.parameters)

		newParameters[param] = e.currentTarget.value
		this.setState({ parameters: newParameters })
	}

	updateDateParameter = (e, value) => {
		var newParameters = Object.assign({}, this.state.parameters)
		var date
		if (value[0]) {
			date = { datetime: value[0], offset: value[0].getTimezoneOffset() * 60000 }

		} else {
			date = undefined
		}

		newParameters[e] = date
		this.setState({ parameters: newParameters })
	}

	updateDateTimeParameter = (e, value) => {
		var newParameters = Object.assign({}, this.state.parameters)
		if (value[0]) {
			newParameters[e] = { datetime: value[0], offset: value[0].getTimezoneOffset() * 60000 }
		} else {
			newParameters[e] = undefined
		}
		//newParameters.offset = value[0].getTimezoneOffset() * 60000
		this.setState({ parameters: newParameters })
	}

	runReport = (exp, e) => {
		var reportParams = Object.assign({}, this.state.parameters)
		var date = new Date(); date.setMonth(0)
		reportParams.timeZone = /\((.*)\)/.exec(date.toString())[1]
		reportParams.route = this.state.activeReport.route
		reportParams.report = this.state.activeReport
		reportParams.exp = exp

		this.props.ws.send(JSON.stringify(reportParams))
	}

	base64ToBlob = (base64Data, contentType) => {

		contentType = contentType || '';
		var sliceSize = 1024;
		var byteCharacters = atob(base64Data);
		var bytesLength = byteCharacters.length;
		var slicesCount = Math.ceil(bytesLength / sliceSize);
		var byteArrays = new Array(slicesCount);

		for (var sliceIndex = 0; sliceIndex < slicesCount; ++sliceIndex) {
			var begin = sliceIndex * sliceSize;
			var end = Math.min(begin + sliceSize, bytesLength);

			var bytes = new Array(end - begin);
			for (var offset = begin, i = 0; offset < end; ++i, ++offset) {
				bytes[i] = byteCharacters[offset].charCodeAt(0);
			}
			byteArrays[sliceIndex] = new Uint8Array(bytes);
		}
		return new Blob(byteArrays, { type: contentType });
	}

	displayDateFilter = (active) => (e) => {
		this.setState({ dateFilter: active })
	}
	displayGroupBy = (active) => (e) => {
		this.setState({ groupBy: active })
	}
	// shouldComponentUpdate(nextProps, nextState) {
	// console.log('considering changes')
	// return true
	// if (this.props.active !== nextProps.active) {
	// return true
	// } else if (JSON.stringify(this.state.activeReport) !== JSON.stringify(nextState.activeReport)) {
	// return true
	// } else if (JSON.stringify(this.state.parameters) !== JSON.stringify(nextState.parameters)) {
	// return true
	// } else if (JSON.stringify(this.props.data.download) !== JSON.stringify(nextProps.data.download)) {
	// return true
	// } else if (JSON.stringify(this.props.data.dynamicParams) !== JSON.stringify(nextProps.data.dynamicParams)) {
	// console.log('params changed')
	// return true
	// } else if (JSON.stringify(this.props.data.reportData) !== JSON.stringify(nextProps.data.reportData)) {
	// return true
	// } else if (this.props.data.reportLoading) {
	// return true
	// } else {
	// return false
	// }
	// }
	handleDownload = () => {
		const fileUrl = this.props.data.reportData.recording;
		window.open(fileUrl, '_blank');
	}

	// Request the option lists for any 'dynamic' report parameters. This must NOT
	// happen inside render(): sending on the socket is a side effect, and if the
	// socket is missing or not yet OPEN (e.g. during a reconnect) it throws and
	// blanks the whole app. Fire it from lifecycle instead, guarded on ws state,
	// and only once per parameter per selected report.
	requestDynamicParams = () => {
		var report = this.state.activeReport
		if (!report || !report.parameters) return
		if (!this.props.ws || this.props.ws.readyState !== 1) return
		if (!this.requestedDynamicParams) this.requestedDynamicParams = {}
		for (var parameter of report.parameters) {
			if (parameter.type !== 'dynamic') continue
			var haveOptions = this.props.data.dynamicParams && this.props.data.dynamicParams[parameter.parameter]
			if (haveOptions || this.requestedDynamicParams[parameter.parameter]) continue
			this.requestedDynamicParams[parameter.parameter] = true
			this.props.ws.send(JSON.stringify({ route: report.route + '_' + parameter.parameter }))
		}
	}

	componentDidMount() {
		this.requestDynamicParams()
	}

	componentDidUpdate(prevProps, prevState) {
		// A different report was selected: forget which dynamic params we've asked for.
		if (prevState.activeReport !== this.state.activeReport) {
			this.requestedDynamicParams = {}
		}
		this.requestDynamicParams()
		if (this.props.data.download && this.props.data.download.data && (!prevProps.data.download || this.props.data.download.data !== prevProps.data.download.data)) {
			console.log('downloading!')
			if (window.navigator.msSaveOrOpenBlob) {
				console.log('This is IE!')
				var fileData = this.base64ToBlob(this.props.data.download.data, "application/zip");
				var blobObject = new Blob([fileData]);

				window.navigator.msSaveOrOpenBlob(blobObject, this.state.activeReport.name + ' -- ' + new Date().toISOString() + '.' + this.props.data.download.type);

			} else {
				var url = window.URL.createObjectURL(this.base64ToBlob(this.props.data.download.data, "application/zip"));
				var a = document.createElement("a");
				a.style = "display: none";
				a.href = url;
				a.download = this.state.activeReport.name + ' -- ' + new Date().toISOString() + '.' + this.props.data.download.type;

				document.body.appendChild(a);
				a.click();
				document.body.removeChild(a);
			}
		}
	}
	confirmDateFilter = (data) => {
		var newParams = Object.assign({}, this.state.parameters)
		newParams.dateFilter = data
		this.setState({ parameters: newParams, dateFilter: false })
	}
	confirmGroupBy = (data) => {
		var newParams = Object.assign({}, this.state.parameters)
		newParams.groupBy = data
		this.setState({ parameters: newParams, groupBy: false })
	}
	convertSec(sec) {
		sec = Math.round(sec)
		var d, h, m, s;
		s = sec
		m = Math.floor(s / 60);
		s = s % 60;
		h = Math.floor(m / 60);
		m = m % 60;
		d = Math.floor(h / 24);
		h = h % 24;

		var time = ''

		d > 0 ? time += d + ' days, ' : time += ''
		h < 1 ? time += '' : h > 0 && h < 10 ? time += '0' + h + ':' : time += h + ':'
		m < 1 ? time += '00:' : m < 10 ? time += '0' + m + ':' : time += m + ':'
		s < 1 ? time += '00' : s < 10 ? time += '0' + s : time += s

		return time;
	};
	formatPhoneNumber(num) {
		if (!num) { return false };
		if (num.length === 0) {
			return "No Number Available"
		} else if (num.length < 7) {
			return num;
		} else if (num.length === 7) {
			return (num.substring(0, 3) + '-' + num.substring(3, 7))
		} else if (num.length === 10) {
			return ('(' + num.substring(0, 3) + ') ' + num.substring(3, 6) + '-' + num.substring(6, 10))
		} else if (num.length === 11) {
			return ('(' + num.substring(1, 4) + ') ' + num.substring(4, 7) + '-' + num.substring(7, 11))
		} else if (num.length === 12) {
			return ('(' + num.substring(2, 5) + ') ' + num.substring(5, 8) + '-' + num.substring(8, 12))
		} else {
			return num;
		}
	}

	render() {
		if (this.props.active) {
			var reports = []
			for (var rep of this.props.data.Reports.reportList) {
				reports.push(
					<div className="dataRow" style={{ padding: '0px 10px' }} key={rep.route} data-report={JSON.stringify(rep)} onClick={this.selectReport} >{rep.name}</div>
				)
			}

			var activeReport = ""
			var row
			if (this.state.activeReport && this.state.activeReport.name) {
				var paramHeaders = []
				var reportParams = []
				var choice
				var parameterOptions
				for (var parameter of this.state.activeReport.parameters) {
					paramHeaders.push(
						<div key={parameter.label}>{parameter.label}</div>
					)
					if (parameter.type === 'datetime') {
						console.log(parameter.parameter)
						if (parameter.parameter == 'end') {
							reportParams.push(
								<Flatpickr key={parameter.label} data-enable-time options={{ dateFormat: "Y-m-d h:i K", defaultHour: 23, defaultMinute: 59 }} value={this.state.parameters[parameter.parameter] ? this.state.parameters[parameter.parameter].datetime : null} onChange={this.updateDateTimeParameter.bind(this, parameter.parameter)} />
							)
						} else {
							reportParams.push(
								<Flatpickr key={parameter.label} data-enable-time options={{ dateFormat: "Y-m-d h:i K", defaultHour: 0, defaultMinute: 0 }} value={this.state.parameters[parameter.parameter] ? this.state.parameters[parameter.parameter].datetime : null} onChange={this.updateDateTimeParameter.bind(this, parameter.parameter)} />
							)
						}

					} else if (parameter.type === 'date') {
						reportParams.push(
							<Flatpickr key={parameter.label} options={{ dateFormat: "Y-m-d h:i K", defaultHour: 0, defaultMinute: 0 }} value={!this.state.parameters[parameter.parameter] || this.state.parameters[parameter.parameter].datetime} onChange={this.updateDateParameter.bind(this, parameter.parameter)} />
						)
					} else if (parameter.type === 'text') {
						reportParams.push(
							<input key={parameter.label} type="text" value={this.state.parameters[parameter.parameter]} onChange={this.updateReportParameter.bind(this, parameter.parameter)} />
						)
					} else if (parameter.type === 'dateFilter') {
						var typeCount = 0
						var filterCount = 0
						for (var type in this.state.parameters[parameter.parameter]) {
							var typeUsed = false
							for (var param in this.state.parameters[parameter.parameter][type]) {
								if (this.state.parameters[parameter.parameter][type][param]) {
									filterCount++
									typeUsed = true
								}
							}
							if (typeUsed) {
								typeCount++
							}
						}
						var val = filterCount > 0 ? (filterCount + (filterCount > 1 ? ' Filters' : ' Filter') + ' in ' + typeCount + (typeCount > 1 ? ' Categories' : ' Category')) : ''
						console.log(val)
						reportParams.push(
							<input key={parameter.label} type="text" defaultValue={val} onFocus={this.displayDateFilter(true)} />
						)


					} else if (parameter.type === 'groupBy') {
						var typeList = []
						for (var type in this.state.parameters[parameter.parameter]) {
							if (this.state.parameters[parameter.parameter][type]) {
								typeList.push(type)
							}
						}

						reportParams.push(
							<input key={parameter.label} type="text" defaultValue={typeList.join(', ')} onFocus={this.displayGroupBy(true)} />
						)
					} else if (parameter.type === 'dropdown') {
						parameterOptions = [<option value={null} key="blankOption"></option>]
						for (choice of parameter.options) {
							parameterOptions.push(
								<option value={choice} key={choice}>{choice}</option>
							)
						}

						reportParams.push(
							<select key={parameter.label} onChange={this.updateReportParameter.bind(this, parameter.parameter)} value={this.state.parameters[parameter.parameter]}>
								{parameterOptions}
							</select>
						)
					} else if (parameter.type === 'dynamic') {
						console.log(this.props.data.dynamicParams);
						if (this.props.data.dynamicParams && this.props.data.dynamicParams[parameter.parameter]) {
							console.log('this.props.data.dynamicParams');
							console.log(this.props.data.dynamicParams);
							parameterOptions = [<option value={null} key="blankOption"></option>]
							for (choice of this.props.data.dynamicParams[parameter.parameter]) {
								parameterOptions.push(
									<option value={choice} key={choice}>{choice}</option>
								)
							}
							reportParams.push(
								<select key={parameter.label} onChange={this.updateReportParameter.bind(this, parameter.parameter)} value={this.state.parameters[parameter.parameter]}>
									{parameterOptions}
								</select>
							)
						} else {
							// Options not loaded yet — requestDynamicParams() (lifecycle) fetches
							// them; render a plain input in the meantime. Do NOT send here.
							reportParams.push(
								<input key={parameter.label} type="text" value={this.state.parameters[parameter.parameter]} onChange={this.updateReportParameter.bind(this, parameter.parameter)} />
							)
						}
					}
				}
				paramHeaders.push(
					<div key="paramHeader"></div>
				)

				var report = []
				var rows, i, options, columns

				if (this.props.data.reportData) {
					if (this.props.data.reportData.graph) {
						if (this.props.data.reportData.graph.type === 'pie') {
							report.push(
								<div key="piechart">
									<h2 style={{ textAlign: 'center', color: '#2A6AA9' }}>{this.props.data.reportData.graph.title}</h2>
									<div className="mini-chart-container" style={{ display: 'inline-block', width: '100%', height: '40vh' }}>

										<Chart

											chartType="PieChart"
											columns={this.props.data.reportData.graph.columns}
											rows={this.props.data.reportData.graph.rows}
											options={
												{
													pieHole: 0,
													legend: 'labeled',
													sliceVisibilityThreshold: 0,
													pieStartAngle: 90,
													pieSliceTextStyle: { color: '#fff', fontSize: '1vw' },
													chartArea: { width: "90%", height: "90%" }
												}
											}
											graph_id="pieChart"
											height="100%"
											width="100%"
										/>
									</div>
								</div>
							)
						} else if (this.props.data.reportData.graph.type === 'bar') {
							rows = this.props.data.reportData.graph.rows.slice()

							for (i = 0; i < this.props.data.reportData.graph.columns.length; i++) {
								if (this.props.data.reportData.graph.columns[i].type === 'datetime') {
									for (row of rows) {
										if (row[i]) { row[i] = new Date(row[i]) }
									}
								} else if (this.props.data.reportData.graph.columns[i].type === 'number') {
									for (row of rows) {
										if (row[i]) { row[i] = parseInt(row[i], 10) }
									}
								} else if (this.props.data.reportData.graph.columns[i].role === 'tooltip') {
									for (row of rows) {
										if (row[i]) {
											var day = new Date(row[0]).getDay()
											switch (day) {
												case 0:
													day = 'Sunday'
													break;
												case 1:
													day = 'Monday'
													break;
												case 2:
													day = 'Tuesday'
													break;
												case 3:
													day = 'Wednesday'
													break;
												case 4:
													day = 'Thursday'
													break;
												case 5:
													day = 'Friday'
													break;
												case 6:
													day = 'Saturday'
													break;
												default:
													day = null
											}

											var time = new Date(row[0]).toLocaleTimeString()
											row[i] = day + ' ' + time + '<br/> ' + this.props.data.reportData.graph.columns[1].label + ': ' + row[1]
										}
									}
								}
							}
							options = {
								vAxis: { format: 0, gridlines: { count: -1 }, title: this.props.data.reportData.graph.columns[1].label, titleTextStyle: { italic: false, fontSize: 18, color: '#2A6AA9' } },
								chartArea: { width: "90%", height: "70%" },
								legend: { position: 'none' },
								animation: { duration: 500 },
								colors: ['#2A6AA9'], bar: { groupWidth: 15 }, tooltip: { isHtml: true }
							}
							columns = this.props.data.reportData.graph.columns

							//[{type: 'datetime', label: 'Time'},{ type: 'number', label: 'Number of Calls'},{type: 'string', role: 'tooltip', p: {html: true}}]

							options.hAxis = {
								format: 'EEEE',
								gridlines: {
									count: -1,
									units: { days: { format: 'EEEE' } }
								}
							}

							report.push(
								<div className="chart-container" style={{ display: 'inline-block', width: '100%' }}>
									<h2 style={{ textAlign: 'center', color: '#2A6AA9', marginBottom: '0px' }}>{module.title}</h2>
									<Chart
										chartType="ColumnChart"
										columns={columns}
										rows={rows}
										options={options}
										graph_id="historyChart"
										width="100%"
									/>
								</div>
							)
						} else if (this.props.data.reportData.graph.type === 'area') {
							rows = this.props.data.reportData.graph.rows.slice()

							for (i = 0; i < this.props.data.reportData.graph.columns.length; i++) {
								if (this.props.data.reportData.graph.columns[i].type === 'datetime' || this.props.data.reportData.graph.columns[i].type === 'date') {
									for (row of rows) {
										if (row[i]) { row[i] = new Date(row[i]) }
									}
								} else if (this.props.data.reportData.graph.columns[i].type === 'number') {
									for (row of rows) {
										//if(row[i]){row[i] = parseInt(row[i],10)}
									}
								}
							}
							options = {
								vAxis: { gridlines: { count: 0 } },
								series: {
									0: {
										type: "Area",
										areaOpacity: .3
									},
									1: {
										type: "Area",
										areaOpacity: 1
									}
								},
								areaOpacity: 1,
								title: this.props.data.reportData.graph.columns[1].label,
								titleTextStyle: { italic: false, fontSize: 18, color: '#2A6AA9' },
								chartArea: { width: "90%", height: "70%" },
								legend: { position: 'none' },
								isStacked: false,
								animation: { duration: 500 },
								colors: ['#2A6AA9', '#937'], bar: { groupWidth: 15 }, tooltip: { isHtml: true }
							}

							columns = this.props.data.reportData.graph.columns


							report.push(
								<div className="chart-container" style={{ display: 'inline-block', width: '100%' }}>
									<h2 style={{ textAlign: 'center', color: '#2A6AA9', marginBottom: '0px' }}>{module.title}</h2>
									<Chart
										chartType="SteppedAreaChart"
										columns={columns}
										rows={rows}
										options={options}
										graph_id="historyChart"
										width="100%"
									/>
								</div>
							)
						} else if (this.props.data.reportData.graph.type === 'timeline') {
							rows = this.props.data.reportData.graph.rows.slice()

							for (i = 0; i < this.props.data.reportData.graph.columns.length; i++) {
								if (this.props.data.reportData.graph.columns[i].type === 'datetime' || this.props.data.reportData.graph.columns[i].type === 'date') {
									for (row of rows) {
										if (row[i]) { row[i] = new Date(row[i]) }
									}
								} else if (this.props.data.reportData.graph.columns[i].type === 'number') {
									for (row of rows) {
										//if(row[i]){row[i] = parseInt(row[i],10)}
									}
								}
							}
							options = {
								height: 100,
								vAxis: { gridlines: { count: 0 } },
								timeline: {
									showBarLabels: false
								},
								title: this.props.data.reportData.graph.columns[1].label,
								titleTextStyle: { italic: false, fontSize: 18, color: '#2A6AA9' },
								chartArea: { width: "90%", height: "70%" },
								legend: { position: 'none' },
								colors: this.props.data.reportData.graph.colors,
								bar: { groupWidth: 15 },
								tooltip: { isHtml: true }
							}

							columns = this.props.data.reportData.graph.columns


							report.push(
								<div className="chart-container" style={{ display: 'inline-block', width: '100%' }}>
									<h2 style={{ textAlign: 'center', color: '#2A6AA9', marginBottom: '0px' }}>{module.title}</h2>
									<Chart
										chartType="Timeline"
										columns={columns}
										rows={rows}
										options={options}
										graph_id="historyChart"
										width="100%"
										height="100px"
									/>
								</div>
							)
						}
					}

					if (this.props.data.reportData.list) {
						for (var data in this.props.data.reportData.list) {
							if (this.props.data.reportData.list[data] === null) {
								report.push(<div key={data} className="reportRow"></div>)
							} else {
								report.push(<div key={data} className="reportRow">{data + ': ' + this.props.data.reportData.list[data]}</div>)
							}

						}
					}

					if (this.props.data.reportData.table) {
						for (i = 0; i < this.props.data.reportData.table.columns.length; i++) {
							if (this.props.data.reportData.table.columns[i].type === 'datetime') {
								for (row of this.props.data.reportData.table.rows) {
									if (row[i]) { row[i] = new Date(row[i]) }
								}
							} else if (this.props.data.reportData.table.columns[i].type === 'month') {
								this.props.data.reportData.table.columns[i].type = 'number'
								for (row of this.props.data.reportData.table.rows) {
									var months = ["January", 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December']
									if (row[i] != null) {
										row[i] = { v: row[i], f: months[row[i] - 1] }
									}
								}
							} else if (this.props.data.reportData.table.columns[i].type === 'day') {
								this.props.data.reportData.table.columns[i].type = 'number'
								for (row of this.props.data.reportData.table.rows) {
									var days = ["Sunday", 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday']
									if (row[i] != null) {
										row[i] = { v: row[i], f: days[row[i] - 1] }
									}
								}
							} else if (this.props.data.reportData.table.columns[i].type === 'hour') {
								this.props.data.reportData.table.columns[i].type = 'number'
								for (row of this.props.data.reportData.table.rows) {
									var hours = ['12:00am', '1:00am', '2:00am', '3:00am', '4:00am', '5:00am', '6:00am', '7:00am', '8:00am', '9:00am', '10:00am', '11:00am', '12:00pm', '1:00pm', '2:00pm', '3:00pm', '4:00pm', '5:00pm', '6:00pm', '7:00pm', '8:00pm', '9:00pm', '10:00pm', '11:00pm']
									if (row[i] != null) {
										row[i] = { v: row[i], f: hours[row[i]] }
									}
								}
							} else if (this.props.data.reportData.table.columns[i].type === 'toNumber') {
								this.props.data.reportData.table.columns[i].type = 'number'
								for (row of this.props.data.reportData.table.rows) {
									row[i] = parseInt(row[i])
								}
							} else if (this.props.data.reportData.table.columns[i].type === 'phone') {
								for (row of this.props.data.reportData.table.rows) {
									this.props.data.reportData.table.columns[i].type = 'string'
									if (row[i]) { row[i] = this.formatPhoneNumber(row[i], 10) }
								}
							} else if (this.props.data.reportData.table.columns[i].type === 'percentage') {
								this.props.data.reportData.table.columns[i].type = 'number'
								for (row of this.props.data.reportData.table.rows) {
									row[i] = { v: row[i], f: row[i] + '%' }
								}
							} else if (this.props.data.reportData.table.columns[i].type === 'timeofday') {
								for (row of this.props.data.reportData.table.rows) {
									if (row[i]) { row[i] = JSON.parse(row[i]) }
								}
							} else if (this.props.data.reportData.table.columns[i].type === 'recording') {
								this.props.data.reportData.table.columns[i].type = 'string'
								for (row of this.props.data.reportData.table.rows) {
									if (row[i]) { row[i] = '<div style="left: Calc(50% - 7.5px); cursor: pointer; position: relative;border-radius: 15px; height: 15px; width: 15px; background-color: #933;" onclick="window.ReportsFunctions.play({sid:\'' + row[i] + '\', callerID: \'' + row[1] + '\' , dateTime:\'' + row[2] + '\' });"></div>' }
								}
							} else if (this.props.data.reportData.table.columns[i].type === 'extraData') {
								this.props.data.reportData.table.columns[i].type = 'string'
								for (row of this.props.data.reportData.table.rows) {

									if (row[i] && row[i] !== 'null' && Object.keys(JSON.parse(row[i])).length > 2) {
										row[i] = '<div style="left: Calc(50% - 7.5px); cursor: pointer; position: relative;border-radius: 15px; height: 15px; width: 15px; background-color: #397;" onclick="window.ReportsFunctions.viewExtraData(\'' + encodeURIComponent(row[i]).replace(/[!'()*]/g, escape) + '\');"></div>'
									} else {
										row[i] = null
									}
								}
							} else if (this.props.data.reportData.table.columns[i].type === 'transcript') {
								this.props.data.reportData.table.columns[i].type = 'string'
								for (row of this.props.data.reportData.table.rows) {

									if (row[i] && row[i] !== 'null' && Object.keys(JSON.parse(row[i])).length > 0) {
										row[i] = '<div style="left: Calc(50% - 7.5px); cursor: pointer; position: relative;border-radius: 15px; height: 15px; width: 15px; background-color: #397;" onclick="window.ReportsFunctions.viewTranscript(\'' + encodeURIComponent(row[i]).replace(/[!'()*]/g, escape) + '\');"></div>'
									} else {
										row[i] = null
									}
								}
							}
						}

						if (this.props.data.reportData.table.rows.length > 0) {
							var dataArray = []
							for (var col of this.props.data.reportData.table.columns) {
								dataArray.push(col.label)
							}
							report.push(<div key="recordCount">{this.props.data.reportData.table.rows.length === 100000 ? 'First 100,000 Records Displayed' : 'Total Records Returned: ' + this.props.data.reportData.table.rows.length}</div>)
							report.push(
								<div key="chartWrapper">
									<Chart
										chartType="Table"
										options={{
											allowHtml: true,
											page: 'enable',
											pageSize: 100,
											pagingButtons: 'auto',
											width: '100%',
											sortColumn: this.state.sortColumn,
											sortAscending: this.state.sortAscending

										}}
										data={[dataArray].concat(this.props.data.reportData.table.rows)}
										graph_id={"reportTable"}
										chartEvents={[
											{
												eventName: "ready",
												callback: ({ chartWrapper, google }) => {
													const chart = chartWrapper.getChart();
													google.visualization.events.addListener(chart, "sort", ({ column, ascending }) => {
														this.setState({ sortColumn: column, sortAscending: ascending })
														console.log("Sorted ", { column, ascending });
													});
												}
											}
										]}

									/>
								</div>
							)
						} else {
							report.push(<div key="noresults">No Results Returned</div>)
						}
					}
				}

				activeReport = (
					<div className="blackout">
						<div className="pop">
							<div style={{ fontSize: '24px', padding: '15px' }}>{this.state.activeReport.name}</div>

							{this.props.data.reportData ? <img alt="Excel Icon" src={excel} onClick={this.runReport.bind(this, "excel")} style={{ cursor: "pointer", position: "absolute", top: "50px", right: "72px" }} /> : ''}

							{this.props.data.reportData ? <img alt="CSV Icon" src={csv} onClick={this.runReport.bind(this, "csv")} style={{ cursor: "pointer", position: "absolute", top: "50px", right: "132px" }} /> : ''}

							{false && this.props.data.reportData ? <img alt="PDF Icon" src={pdf} onClick={this.runReport.bind(this, "pdf")} style={{ cursor: "pointer", position: "absolute", top: "50px", right: "192px" }} /> : ''}

							{false && this.props.data.reportData && (!this.props.data.reportData.table || this.props.data.reportData.table.rows.length < 5001) ? <img alt="Print Icon" src={print} onClick={window.print} style={{ cursor: "pointer", position: "absolute", height: "30px", top: "50px", right: "192px" }} /> : ''}

							<div className="viewCloser" style={{ display: 'block' }} onClick={this.cancelReport}></div>

							<div style={{ margin: '5px 0px 5px 0px' }} className="reportHeaders">
								{paramHeaders}
							</div>

							<div style={{ margin: '5px 0px 15px 0px' }} className="reportFilters">
								{reportParams}
								<div className="button" onClick={this.runReport.bind(this, false)} >Start</div>
							</div>

							{this.props.data.reportLoading ? <div style={{ position: "static", height: "100px" }}><div style={{ position: "absolute", left: "50%", transform: "translateX(-50%)" }}><div style={{ margin: "100px" }} className="loader"></div></div></div> : report}

						</div>
					</div>
				)
			}

			var recordingPlayer = ""
			if (this.state.playingRecording) {
				recordingPlayer = (
					<div className="blackout" onClick={this.stopClick}>
						<div className="pop">
							<div className="viewCloser" style={{ display: 'block' }} onClick={this.cancel}></div>
							<div className="loginLabel">Listen to or Download Recording</div>
							<div className="error">{this.state.recordingError}</div>
							{!this.props.data.reportData.recording ? '' : <audio id="recordingPlayer" style={{ width: "500px", height: "50px", margin: "25px" }} src={this.props.data.reportData.recording} download={this.state.activeCall + '.wav'} controls controlsList="nofullscreen nodownload noremoteplayback" />}
							{!this.props.data.reportData.recording ? <div className="loader"></div> : <div className="button" onClick={this.handleDownload}>Download Recording</div>}
						</div>
					</div>
				)
			}




			var extraDataViewer = ""
			if (this.state.extraData) {
				var dataRows = []
				var data = JSON.parse(JSON.stringify(this.state.extraData))
				if (typeof data == 'string') {
					data = JSON.parse(data)
				}
				if (data instanceof Array) {
					for (var item of data) {
						for (var param in item) {
							dataRows.push(
								<div style={{ display: 'flex', justifyContent: 'space-between', padding: '25px' }}>
									<div style={{ paddingRight: '25px' }}>{param}:</div>
									<div>{item[param]}</div>
								</div>
							)
						}
						dataRows.push(<hr></hr>)
					}
				} else {
					for (var param in this.state.extraData) {
						if (param != 'twilio') {
							dataRows.push(
								<div style={{ display: 'flex', justifyContent: 'space-between', padding: '25px' }}>
									<div style={{ paddingRight: '25px' }}>{param}:</div>
									<div>{this.state.extraData[param]}</div>
								</div>
							)
						}

					}
				}
				extraDataViewer = (
					<div className="blackout" onClick={this.cancel}>
						<div className="pop">
							<div className="viewCloser" style={{ display: 'block' }} onClick={this.cancel}></div>
							<div className="loginLabel">Additional Data</div>
							{dataRows}
						</div>
					</div>
				)
			}

			var transcriptViewer = ""
			if (this.state.transcript) {
				var dataRows = []
				var data = JSON.parse(JSON.stringify(this.state.transcript))
				if (typeof data == 'string') {
					data = JSON.parse(data)
				}
				var messages = []
				for (var message of data) {
					if (message.direction == 1) {
						messages.push(
							<div style={{ background: 'rgb(221, 221, 221)', border: '1px solid #e0e0e0', borderRadius: '20px', color: 'rgba(0,0,0,0.87)', flex: '0 0 auto', fontFamily: 'Roboto, sans-serif', fontSize: '14px', marginTop: '10px', maxWidth: 'calc(100% - 28px)', padding: '7px 16px', wordBreak: 'break-word', wordWrap: 'break-word', alignSelf: 'flex-end', backgroundColor: '#ddd', marginLeft: '75px' }}>{message.message}</div>
						)
						messages.push(
							<div style={{ color: 'rgba(0,0,0,0.7)', flex: '0 0 auto', fontFamily: 'Roboto, sans-serif', fontSize: '12px', marginTop: '5px', maxWidth: 'calc(100% - 28px)', wordBreak: 'break-word', wordWrap: 'break-word', alignSelf: 'flex-end', marginLeft: '75px' }}>{new Date(message.timestamp).toLocaleString()}</div>
						)
					} else if (message.direction == 0) {
						for (var segment of message.message) {
							if (!segment.hasOwnProperty('platform')) {
								if (segment.hasOwnProperty('text')) {
									messages.push(
										<div style={{ background: 'rgb(221, 221, 221)', border: '1px solid #e0e0e0', borderRadius: '20px', color: 'rgba(0,0,0,0.87)', flex: '0 0 auto', fontFamily: 'Roboto, sans-serif', fontSize: '14px', marginTop: '10px', maxWidth: 'calc(100% - 28px)', padding: '7px 16px', wordBreak: 'break-word', wordWrap: 'break-word', alignSelf: 'flex-start', backgroundColor: '#fff', marginRight: '75px' }}>{segment.text.text[0]}</div>
									)

								} else if (segment.hasOwnProperty('payload')) {
									if (segment.payload.richContent[0][0].type == 'chips') {
										messages.push(
											<a style={{ textAlign: 'center' }} href={segment.payload.richContent[0][0].options[0].link}>
												<div style={{ display: 'inline-block', background: 'rgb(221, 221, 221)', border: '1px solid #e0e0e0', borderRadius: '20px', color: 'rgba(0,0,0,0.87)', flex: '0 0 auto', fontFamily: 'Roboto, sans-serif', fontSize: '14px', marginTop: '10px', maxWidth: 'calc(100% - 28px)', padding: '7px 16px', wordBreak: 'break-word', wordWrap: 'break-word', alignSelf: 'flex-start', backgroundColor: '#fff', marginRight: '75px' }}>

													<span>{segment.payload.richContent[0][0].options[0].text}</span>
													<svg xmlns='http://www.w3.org/2000/svg' fill='black' height='15' viewBox='0 0 24 24' width='15'>
														<path d='M0 0h24v24H0z' fill='none' /> <path d='M19 19H5V5h7V3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2v-7h-2v7zM14 3v2h3.59l-9.83 9.83 1.41 1.41L19 6.41V10h2V3h-7z' />
													</svg>
												</div>


											</a>
										)
									} else if (segment.payload.richContent[0][0].type == 'image') {
										messages.push(
											<img src={segment.payload.richContent[0][0].rawUrl} style={{ width: '100%' }} />

										)
									}

								}
							}
						}
						messages.push(
							<div style={{ color: 'rgba(0,0,0,0.7)', flex: '0 0 auto', fontFamily: 'Roboto, sans-serif', fontSize: '12px', marginTop: '5px', maxWidth: 'calc(100% - 28px)', wordBreak: 'break-word', wordWrap: 'break-word', alignSelf: 'flex-start', marginRight: '75px' }}>{new Date(message.timestamp).toLocaleString()}</div>
						)
					}
				}


				transcriptViewer = (
					<div className="blackout" >
						<div className="pop">
							<div className="viewCloser" style={{ display: 'block' }} onClick={this.cancel}></div>
							<div className="loginLabel">Chatbot Transcript</div>
							<div key={'chatbox'} style={{ backgroundColor: '#e5e5e5', textAlign: 'left', margin: '50px', height: '560px', borderRadius: '4px', boxShadow: 'rgba(0, 0, 0, 0.5) 1px 4px 15px 0px', display: 'flex', flexDirection: 'column', position: 'relative', transform: 'translateX(0%) translateY(0%) scale(1, 1)', opacity: 1, transition: 'transform 0.2s ease, opacity 0.2s ease-in, height 0s ease 0.2s', width: '370px', overflow: 'hidden' }}>
								<div style={{ alignItems: 'center', zIndex: 2, backgroundColor: '#ffffff', borderRadius: '5px 5px 0 0', boxShadow: '0px 3px 6px 0px #00000080', color: '#009ada', display: 'flex', fontFamily: 'Roboto, sans-serif', fontSize: '18px', height: '50px', justifyContent: 'space-between', paddingLeft: '15px' }}>{this.props.data.Chatbot.chatTitle}</div>
								<div style={{ display: 'flex', backgroundColor: '#fff', flexDirection: 'column', flex: '1 1', overflowX: 'hidden', overflowY: 'scroll', padding: '10px' }}>{messages}</div>
								<div style={{ borderTop: '1px solid #eeeeee', backgroundColor: '#fff', display: 'flex', fontFamily: 'Roboto, sans-serif', height: '50px' }}>

								</div>

							</div>
						</div>
					</div>
				)
			}

			return (
				<div className="viewContent" id="reportView" >
					<div style={{ overflow: 'auto', height: 'calc(100% - 5px)' }}>
						{reports}
					</div>

					{activeReport}
					{this.state.dateFilter ? <DateFilter data={this.state.parameters.dateFilter} confirmDateFilters={this.confirmDateFilter} cancel={this.cancel} /> : ''}
					{this.state.groupBy ? <GroupBy data={this.state.parameters.groupBy} confirmDateFilters={this.confirmGroupBy} cancel={this.cancel} /> : ''}
					{recordingPlayer}
					{extraDataViewer}
					{transcriptViewer}
				</div>
			);
		} else {
			return (
				<div width="100%">

				</div>
			);
		}
	}
}



const icon = "menuChart"
const roles = ["View"]
export { Reports, icon, roles }